import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'

const IframeLayout = Loadable({ loader: () => import('layers/lsc-videoDownload/pages/IframePage/IframePage'), loading})


export default (links) => (
  <Route>
    <Route path={links.root} component={IframeLayout} />
    <Redirect path={`${links.root}/*`} to={links.root} />
  </Route>
)
